/**
 * URL parsing utilities for the Help Center
 */

/**
 * Extract path information from URL - SINGLE SOURCE OF TRUTH
 * @returns {Object} Object containing path information
 */
export const getPathFromUrl = () => {
  if (typeof window === "undefined")
    return { type: null, slug: null, categoryPath: null }

  const pathString = window.location.pathname

  // Default values
  let contentType = null
  let slug = null
  let categoryPath = null

  // Check if we're on an article page
  if (pathString.includes("/article/")) {
    contentType = "article"

    // Extract article slug (the last part after /article/)
    const articleMatch = pathString.match(/\/article\/([^\/]+)(?:\/|$)/)
    if (articleMatch && articleMatch[1]) {
      slug = articleMatch[1]

      // Extract category path if it exists (everything between /category/ and /article/)
      const categoryMatch = pathString.match(
        /\/category\/([^\/]+(?:\/[^\/]+)*)\/article\//
      )
      if (categoryMatch && categoryMatch[1]) {
        categoryPath = categoryMatch[1]
      }
    }
  }
  // Check if we're on a category page
  else if (pathString.includes("/category/")) {
    contentType = "category"

    // Extract category path (everything after /category/)
    const categoryMatch = pathString.match(
      /\/category\/([^\/]+(?:\/[^\/]+)*)(?:\/|$)/
    )
    if (categoryMatch && categoryMatch[1]) {
      categoryPath = categoryMatch[1]
      // For categories, the slug is the last segment of the path
      const segments = categoryPath.split("/")
      slug = segments[segments.length - 1]
    }
  }

  return {
    type: contentType,
    slug: slug,
    categoryPath: categoryPath,
    // This is the full exact path that should match only one item
    exactPath:
      contentType === "article"
        ? `${categoryPath}/article/${slug}`
        : categoryPath,
    // Explicitly identify the direct parent category path for an article
    directParentPath: contentType === "article" ? categoryPath : null,
  }
}
